import React, { useState, useEffect } from 'react';
import DataLoaderFileLog from './DataLoaderFileLog';
import DataLoaderLoadFile from './DataLoaderLoadfile';
import dataLoaderServices from './DataLoaderServices';
import DataLoaderTableConfirmation from './DataLoadertableClear';
import DataLoaderFileValidation from './DataLoaderFileValidation';
import Pagination from 'components/Common/newPagination';
import DataLoaderEditLoad from './DataLoaderEditLoad';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import { CommonUtilities } from 'commonUtils';
import ExportOption from 'components/Common/exportOption';

export default function UploadTemplate(param: any) {

    let [LogName, setLogName] = useState("");
    let [progress, setProgress] = useState(0);
    let [openLoadFile, setopenLoadFile] = useState(0);
    let [exportOption, setExportOption] = useState("");
    let [fileToUpload, setfileToUpload] = useState(null);
    let [searchtotalRows, setsearchtotalRows] = useState(0);
    let [viewAlltotalRows, setviewAlltotalRows] = useState(0);
    let [LoadFileStatus, setLoadFileStatus] = useState(false);
    let [searchListing, setsearchListing] = useState<any>([]);
    let [editFormParam, seteditFormParam] = useState<any>([]);
    let [collapsedSearch, setcollapsedSearch] = useState(false);
    let [viewAllListing, setviewAllListing] = useState<any>([]);
    let [showShearchField, setshowShearchField] = useState(false);
    let [showSearchResult, setshowSearchResult] = useState(false);
    let [fileuploadStatus, setfileuploadStatus] = useState(false);
    let [showViewAllResult, setshowViewAllResult] = useState(false);
    let [editUploaderData, setEditUploaderData] = useState<any>([]);
    let [editUploaderStatus, setEditUploaderStatus] = useState(false);
    let [deleteUploaderData, setDeleteUploaderData] = useState<any>([]);
    let [deleteUploaderStatus, setDeleteUploaderStatus] = useState(false);

    useEffect(() => {
        uploadDataCounting();
        setcollapsedSearch(false);
        setshowSearchResult(false);
        showViewAllResult = false;
        setshowViewAllResult(showViewAllResult);

        if (param.subType.length > 0 && dataLoaderServices.dataLoaderSearch.some((filter: any) => filter.fieldFor === param.type && filter.for === param.subType)) {
            setshowShearchField(true)
        } else if (param.subType.length == 0 && dataLoaderServices.dataLoaderSearch.some((filter: any) => filter.fieldFor === param.type)) {
            setshowShearchField(true)
        } else {
            setshowShearchField(false)
        }

        openLoadFile = 0
        setopenLoadFile(openLoadFile)
        progress = 0;
        setProgress(progress)

        var list = dataLoaderServices.logName.filter(
            (item: any) => item?.name.toLocaleLowerCase() === param.type.toLocaleLowerCase()
        );

        if (list[0] && list[0].code) {
            setLogName(list[0].code);
        }

        setfileuploadStatus(false);
        setfileToUpload(null)
        seteditFormParam([])

    }, [param.type, param.subType]);

    const fileupload = (event: any) => {
        const fileName = event.target.files[0];
        console.log(event)
        if (fileName) {
            setfileToUpload(fileName);
            fileuploadStatus = true
            setfileuploadStatus(fileuploadStatus);
        }
    }

    const onChangeLoadFile = (e: any) => {
        if (e === 1) {
            //Appen
            uploadData();
        }
        if (e === 2) {
            //clear
            clearUpload();
            uploadData();
        }
        if (e === 3) {
            //load
            uploadData();
        }
        if (e === 0) {

            setfileuploadStatus(false);
        }

        setLoadFileStatus(false)
    }

    const progressTiming = (e: any) => {

        setProgress(30)

        setProgress(50)

        if (e >= 0) {
            setProgress(100)
        }
    }

    const uploadData = () => {

        console.log(fileToUpload)
        console.log(param)
        if (param.type === 'Contacts') {
            dataLoaderServices.dataLoadContactFileUpload(fileToUpload).then((value: any) => {
                console.log(value)
                progressTiming(value);

                if (typeof (value) == "number") {
                    progress = 100;
                    setProgress(progress)
                }

                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Contracts') {
            dataLoaderServices.dataLoadContractFileUpload(fileToUpload).then((value: any) => {
                progressTiming(value);

                if (typeof (value) == "number") {
                    progress = 100;
                    setProgress(progress)
                }

                if (value) {
                    uploadDataCounting();
                }
            })
        }

        if (param.type === 'Contract Links') {
            dataLoaderServices.dataLoadcontractLinksFileUpload(fileToUpload).then((value: any) => {
                progressTiming(value);

                if (typeof (value) == "number") {
                    progress = 100;
                    setProgress(progress)
                }

                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Upload Mechanicals') {
            dataLoaderServices.dataLoadMechanicalFileUpload(fileToUpload).then((value: any) => {
                progressTiming(value);

                if (typeof (value) == "number") {
                    progress = 100;
                    setProgress(progress)
                }

                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Mappings') {
            console.log(param)
            console.log(fileToUpload)
            var payload = {}
            if (param?.subType === 'mappingTerritory') {
                payload = { "tableName": "[dataload].[Mappings_Territory]", "type": "mappingTerritory" }
            }

            if (param?.subType === 'mappingFormat') {
                payload = { "tableName": "[dataload].[Mappings_Formats]", "type": "mappingFormat" }
            }

            if (param?.subType === 'mappingCatalogue') {
                payload = { "tableName": "[dataload].[Mappings_Catalogues]", "type": "mappingCatalogue" }
            }

            if (param?.subType === 'mappingRaw') {
                payload = { "tableName": "[dataload].[Matching_Invoices]", "type": "mappingRaw" }
            }

            if (param?.subType === 'mappingAudit') {
                payload = { "tableName": "[dataload].[Matching_Invoices]", "type": "mappingAudit" }
            }

            if (param?.subType === 'mappingRawPub') {
                payload = { "tableName": "[dataload].[FactsalesPub_Invoices]", "type": "mappingRawPub" }
            }

            if (param?.subType === 'mappingAuditPub') {
                payload = { "tableName": "[dataload].[FactsalesPub_Invoices]", "type": "mappingAuditPub" }
            }

            if (param?.subType === 'mappingAnalysisCode') {
                payload = { "tableName": "[dataload].[Mappings_AnalysisCodes]", "type": "mappingAnalysisCode" }
            }

            if (param?.subType === 'mappingClassList.excel') {
                payload = { "tableName": "[dataload].[Mappings_ClassLists]", "type": "mappingClassList.excel" }
            }

            if (param?.subType === 'mappingClassList.mpm') {
                payload = { "tableName": "[dataload].[Mappings_ClassLists]", "type": "mappingClassList.mpm" }
            }

            if (param?.subType === 'mappingSong') {
                payload = { "tableName": "[dataload].[Mappings_Songs]", "type": "mappingSong" }
            }

            dataLoaderServices.dataLoadMappingFileUpload(fileToUpload, payload).then((value: any) => {
                progressTiming(value);

                if (typeof (value) == "number") {
                    progress = 100;
                    setProgress(progress)
                }

                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataTransferFileUpload(fileToUpload, { "packageName": "DataTransferMapping" }).then((value: any) => {
                progressTiming(value);

                if (typeof (value) == "number") {
                    progress = 100;
                    setProgress(progress)
                }

                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Bulk Update') {
            //dataLoaderServices.bulkUpdateSummary({type:param.subType}).then((value : any)=>{ uploadDataCounting() }) 
        }

        if (param.type === 'Release/Track' && (param.subType === 'releaseTrack' || param.subType === "Distributor")) {
            dataLoaderServices.genericV1fileUpload(fileToUpload, { tableName: "MetaDataGenericV1" }).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }

                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Release/Track' && param.subType === 'Releases') {
            dataLoaderServices.genericV1fileUpload(fileToUpload, { tableName: "MetaDataGenericCompilations" }).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Release/Track' && param.subType === 'Track') {
            dataLoaderServices.genericV1fileUpload(fileToUpload, { tableName: "MetaDataGenericTracks" }).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'CWR') {
            dataLoaderServices.cwrUpload(fileToUpload).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'CUE') {
            dataLoaderServices.cuefileUpload(fileToUpload).then((value: any) => {
                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Song') {
            dataLoaderServices.songUpload(fileToUpload).then((value: any) => {
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Minimum Set Uploader' && param.subType === 'Tracks') {
            dataLoaderServices.minimumSetTrackUpload(fileToUpload).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Minimum Set Uploader' && param.subType === 'Releases') {
            dataLoaderServices.minimumSetReleaseUpload(fileToUpload).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Minimum Set Uploader' && param.subType === 'Dealerprice') {
            dataLoaderServices.minimumSetDealerPriceUpload(fileToUpload).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Minimum Set Uploader' && param.subType === 'releaseTrack') {
            dataLoaderServices.minimumSetTrackReleaseUpload(fileToUpload).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

        if (param.type === 'Minimum Set Uploader' && param.subType === 'Songs') {
            dataLoaderServices.minimumSetSongUpload(fileToUpload).then((value: any) => {

                if (typeof (value) == "number") {
                    progress = value;
                    setProgress(progress)
                }
                if (value) {
                    uploadDataCounting();
                    ViewUploadList();
                }
            })
        }

    }

    const uploadDataCounting = () => {
        console.log(param)
        if (param.type === 'Contacts') { dataLoaderServices.dataLoadContactCount().then((value: any) => { setviewAlltotalRows(value) }) }

        if (param.type === 'Contracts') { dataLoaderServices.dataLoadContractCount().then((value: any) => { setviewAlltotalRows(value) }) }

        if (param.type === 'Contract Links') { dataLoaderServices.dataLoadcontractLinksCount().then((value: any) => { setviewAlltotalRows(value) }) }

        if (param.type === 'Minimum Set Uploader') {
            dataLoaderServices.minimumSetMetaData({ type: param.subType }).then((value: any) => { setviewAlltotalRows(value) })
        }

        if (param.type === 'Release/Track') {
            if (param.subType == "releaseTrack" || param.subType == "Distributor") {
                dataLoaderServices.genericV1Count().then((value: any) => { setviewAlltotalRows(value) })
            }
            if (param.subType == "Releases") {
                dataLoaderServices.genericV1TypeCount({ type: "release" }).then((value: any) => { setviewAlltotalRows(value) })
            }

            if (param.subType == "Track") {
                dataLoaderServices.genericV1TypeCount({ type: "track" }).then((value: any) => { setviewAlltotalRows(value) })
            }
        }
        if (param.type === 'CWR') { dataLoaderServices.genericV1Count().then((value: any) => { setviewAlltotalRows(value) }) }

        if (param.type === 'CUE') { dataLoaderServices.CueCount().then((value: any) => { setviewAlltotalRows(value) }) }

        if (param.type === 'Song') { dataLoaderServices.songLoaderCount().then((value: any) => { setviewAlltotalRows(value) }) }

        if (param.type === 'Upload Mechanicals') {
            if (param.subType) {
                dataLoaderServices.dataLoadMechanicalUploadCount({ type: param.subType }).then((value: any) => { setviewAlltotalRows(value) })
            }
        }

        if (param.type === 'Mappings') {
            if (param.subType) {
                dataLoaderServices.dataLoadMappingCount({ type: param.subType }).then((value: any) => { setviewAlltotalRows(value) })
            }
        }

        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataTransferCount(param?.subType).then((value: any) => { setviewAlltotalRows(value) })
        }

        if (param.type === 'Bulk Update') {
            if (param.subType) {
                dataLoaderServices.bulkUpdateSummary({ type: param.subType }).then((value: any) => { setviewAlltotalRows(value) })
            }
        }

    }

    const onFileValidation = (e: any) => {
        setLoadFileStatus(false);
        ViewUploadList();
    }

    const onClearConfirmation = (e: any) => {
        if (e === 1) {
            CommonUtilities.APILoadingToast('Loading', 'fail')
            clearUpload();
        }
        setLoadFileStatus(false)
    }

    const clearUpload = () => {

        if (param.type === 'Contacts') {
            dataLoaderServices.dataLoadContactClear().then((res: any) => {
                apiRespondMgt(res, "Table Clear");
            });
        }

        if (param.type === 'Contracts') {
            dataLoaderServices.dataLoadContractClear().then((res: any) => {
                apiRespondMgt(res, "Table Clear");
            });
        }

        if (param.type === 'Contract Links') {
            dataLoaderServices.dataLoadContractLinksClear().then((res: any) => {
                apiRespondMgt(res, "Table Clear");
            });
        }

        if (param.type === 'Upload Mechanicals') {
            dataLoaderServices.dataLoadMechanicalClear({ type: param.subType }).then((res: any) => {
                apiRespondMgt(res, "Table Clear");
            });
        }

        if (param.type === 'Mappings') {
            dataLoaderServices.dataLoadMappingClear({ type: param.subType }).then((res: any) => { apiRespondMgt(res, "Table Clear"); });
        }

        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataLoadTransferClear({ type: param.subType }).then((res: any) => { apiRespondMgt(res, "Table Clear"); });
        }

        if (param.type === 'Minimum Set Uploader') {
            if (param.subType == "Tracks") {
                dataLoaderServices.clearUploadTrack().then((res: any) => { apiRespondMgt(res, "Table Clear"); });
            }
            if (param.subType == "Releases") {
                dataLoaderServices.clearUploadRelease().then((res: any) => { apiRespondMgt(res, "Table Clear"); });
            }
            if (param.subType == "Dealerprice") {
                dataLoaderServices.clearUploadDealerPrice().then((res: any) => { apiRespondMgt(res, "Table Clear"); });
            }
            if (param.subType == "releaseTrack") {
                dataLoaderServices.clearUploadReleaseTrack().then((res: any) => { apiRespondMgt(res, "Table Clear"); });
            }
            if (param.subType == "Songs") {
                dataLoaderServices.clearUploadSongs().then((res: any) => { apiRespondMgt(res, "Table Clear"); });
            }
        }

        if (param.type == 'Release/Track' && param.subType == 'releaseTrack') {
            dataLoaderServices.clearUploadGenericV1().then((res: any) => { apiRespondMgt(res, "Table Clear"); });;
        }

        if (param.type == 'Release/Track' && param.subType == 'Releases') {
            dataLoaderServices.clearUploadGenericV1release().then((res: any) => { apiRespondMgt(res, "Table Clear"); });;
        }

        if (param.type == 'Release/Track' && param.subType == 'Track') {
            dataLoaderServices.clearUploadGenericV1Track().then((res: any) => { apiRespondMgt(res, "Table Clear"); });;
        }


        if (param.type === 'CUE') {
            dataLoaderServices.cueClear().then((res: any) => { apiRespondMgt(res, "Table Clear"); });
        }

        if (param.type === 'Song') {
            dataLoaderServices.songLoaderclear().then((res: any) => {
                apiRespondMgt(res, "Table Clear");
            });
        }
    }

    const onChangeLogFile = (e: any) => {
        setLoadFileStatus(false)
    }

    var searchListingPayload = {
        type: param.subType,
        pageNumber: 1,
        pageSize: 10,
        AssetType: ""
    }

    const searchForListing = () => {
        CommonUtilities.APILoadingToast('Loading', 'fail')

        if (editFormParam) {
            searchListingPayload = { ...searchListingPayload, ...editFormParam }
        }
        if (param.type === 'Contacts') {
            dataLoaderServices.dataLoadContactSearch(searchListingPayload).then((value: any) => {
                setsearchListing(value); setshowSearchResult(true);
                setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                if (value) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            })
        }

        if (param.type === 'Contracts') {
            dataLoaderServices.dataLoadContractSearch(searchListingPayload).then((value: any) => {
                setsearchListing(value); setshowSearchResult(true);
                setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                if (value) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            })
        }

        if (param.type === 'Contract Links') {
            dataLoaderServices.dataLoadContractLinksSearch(searchListingPayload).then((value: any) => {
                setsearchListing(value); setshowSearchResult(true);
                setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                if (value) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            })
        }

        if (param.type === 'Upload Mechanicals') {

            if (param.subType === "mechanicalContract") {
                dataLoaderServices.dataLoadmechanicalContractSearch(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }

            if (param.subType === "mechanicalTrackSplits") {
                dataLoaderServices.dataLoadMechanicalTrackSplitsSearch(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }

            if (param.subType === "mechanicalLicenses") {
                dataLoaderServices.dataLoadMechanicalLicenseSearch(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }

        }

        if (param.type === 'Minimum Set Uploader') {

            if (param.subType == "Tracks") {
                searchListingPayload.AssetType = "T";
                dataLoaderServices.assetUploaderList(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }
            if (param.subType == "Releases") {
                searchListingPayload.AssetType = "R";
                dataLoaderServices.assetUploaderList(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }
            if (param.subType == "Dealerprice") {
                searchListingPayload.type = "T";
                dataLoaderServices.dealerPriceListing(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }
            if (param.subType == "releaseTrack") {
                searchListingPayload.AssetType = "T";
                dataLoaderServices.releaseTracklisting(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }
            if (param.subType == "Songs") {
                searchListingPayload.AssetType = "S";
                dataLoaderServices.assetUploaderList(searchListingPayload).then((value: any) => {
                    setsearchListing(value); setshowSearchResult(true);
                    setsearchtotalRows(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)

                    if (value) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                })
            }
        }
    }

    const sliderUpdateEditFormParam = (type: any, value: any, InputType: any, InputValue: any) => {
        if ((value[type] === 0 || value[type] === 1) && InputType === "checkbox") {
            value[type] = value[type] === 0 ? 1 : 0;

            seteditFormParam({ ...editFormParam, value })
        }

        else if ((value[type] === true || value[type] === false) && InputType === "checkbox") {
            value[type] = value[type] === false ? true : false;

            seteditFormParam({ ...editFormParam, value })
        } else {
            value[type] = InputValue;
            seteditFormParam({ ...editFormParam, value })
        }

        if (editFormParam && editFormParam.value) {
            delete editFormParam.value
        }
    }

    var viewAllPayload = {
        type: param.subType,
        pageNumber: 1,
        pageSize: 10,
        AssetType: ""
    }

    const ViewUploadList = () => {
        if (param.type === 'Contacts') {
            dataLoaderServices.dataLoadContactViewAll(viewAllPayload).then((value: any) => {
                setviewAllListing(value); setshowViewAllResult(true);
            })
        }

        if (param.type === 'Song') {
            dataLoaderServices.dataLoadSongViewAll(viewAllPayload).then((value: any) => {
                setviewAllListing(value); setshowViewAllResult(true);
            })
        }

        if (param.type === 'Contracts') {
            viewAllPayload.type = ""
            dataLoaderServices.dataLoadContractViewAll(viewAllPayload).then((value: any) => {
                setviewAllListing(value); setshowViewAllResult(true);
            })
        }

        if (param.type === 'Contract Links') {
            dataLoaderServices.dataLoadcontractLinksCount().then((value: any) => {
                setviewAlltotalRows(value ? value : 0)
            })
            dataLoaderServices.dataLoadContractLinksViewAll(viewAllPayload).then((value: any) => {
                setviewAllListing(value); setshowViewAllResult(true);
            })
        }

        if (param.type === 'Upload Mechanicals') {
            dataLoaderServices.dataLoadMechanicalUploadCount({ type: param.subType }).then((value: any) => {
                setviewAlltotalRows(value ? value : 0)
            })

            if (param.subType === "mechanicalContract") {
                dataLoaderServices.dataLoadMechanicalContractViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

            if (param.subType === "mechanicalTrackSplits") {
                dataLoaderServices.dataLoadMechanicalTrackSplitsViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }//mechanicalLicenses

            if (param.subType === "mechanicalLicenses") {
                dataLoaderServices.dataLoadMechanicalLicenseViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

        }

        if (param.type === 'Mappings') {
            dataLoaderServices.dataLoadMappingCount({ type: param.subType }).then((value: any) => {
                setviewAlltotalRows(value ? value : 0)
            })

            if (param.subType === "mappingRaw" || param.subType === "mappingAudit") {
                dataLoaderServices.dataLoadMappingRawViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

            if (param.subType === "mappingRawPub" || param.subType === "mappingAuditPub") {
                dataLoaderServices.dataLoadMappingRawPubViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

            if (param.subType === "mappingFormat") {
                dataLoaderServices.dataLoadmappingformatViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

            if (param.subType === "mappingCatalogue") {
                dataLoaderServices.dataLoadmappingCatalogueViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

            if (param.subType === "mappingAnalysisCode") {
                dataLoaderServices.dataLoadmappinganalysiscodeViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

            if (param.subType === "mappingClassList") {
                dataLoaderServices.dataLoadmappingclasslistViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }

        }

        if (param.type === 'Minimum Set Uploader') {
            if (param.subType == "Tracks") {
                dataLoaderServices.assetUploaderTrackViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                    if (value?.totalRows) {
                        setviewAlltotalRows(value?.totalRows ? value?.totalRows : 0)
                    }
                })
            }
            if (param.subType == "Releases") {
                dataLoaderServices.assetUploaderReleaseViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                    if (value?.totalRows) {
                        setviewAlltotalRows(value?.totalRows ? value?.totalRows : 0)
                    }
                })
            }
            if (param.subType == "Dealerprice") {
                dataLoaderServices.dealerPriceViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                    if (value?.totalRows) {
                        setviewAlltotalRows(value?.totalRows ? value?.totalRows : 0)
                    }
                })
            }
            if (param.subType == "releaseTrack") {
                dataLoaderServices.releaseTrackUploadViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                    if (value?.totalRows) {
                        setviewAlltotalRows(value?.totalRows ? value?.totalRows : 0)
                    }
                })
            }
            if (param.subType == "Songs") {
                dataLoaderServices.songUploadViewAll(viewAllPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                    if (value?.totalRows) {
                        setviewAlltotalRows(value?.totalRows ? value?.totalRows : 0)
                    }
                })
            }
        }

        if (param.type === 'CUE') {

            dataLoaderServices.cueViewAll(viewAllPayload).then((value: any) => {
                setviewAllListing(value); setshowViewAllResult(true);
            })
        }

        if (param.type === 'Release/Track') {
            if (param.subType == "releaseTrack") {
                dataLoaderServices.metaReleaseTrackViewAll(searchListingPayload.pageNumber, searchListingPayload.pageSize).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }
            if (param.subType == "Releases") {
                dataLoaderServices.metaReleaseViewAll(searchListingPayload.pageNumber, searchListingPayload.pageSize).then((value: any) => {
                    setviewAllListing(value?.Table); setshowViewAllResult(true);
                })
            }

            if (param.subType == "Track") {
                dataLoaderServices.metaTrackViewAll(searchListingPayload.pageNumber, searchListingPayload.pageSize).then((value: any) => {
                    setviewAllListing(value?.Table); setshowViewAllResult(true);
                })
            }

            if (param.subType == "Distributor") {
                dataLoaderServices.metaReleaseTrackViewAll(searchListingPayload.pageNumber, searchListingPayload.pageSize).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }
        }

    }

    const onChange = (e: any) => {
        console.log(e)

        if (e.optSts === 1) {

            var payload = {
                pageNumber: -1,
                pageSize: -1,
                type: param.subType,
                fileFormat: e.fileFormat,
                numRows: e.numRows,
                fileName: e.fileName,

            }
            console.log(editFormParam)
            payload = { ...payload, ...editFormParam }
            console.log(payload)
            if (param.type === 'Contract Links') {
                dataLoaderServices.dataLoadContractLinksExport(payload)
            }

            //dataLoaderServices.dataLoadContractLinksExport(payload)
        }

        exportOption = '';
        setExportOption(exportOption)
    }

    const exportListing = () => {

        var ExportPayload = {
            export: true, exportType: param.subType, filName: param.subType
        }

        if (editFormParam) {
            ExportPayload = { ...ExportPayload, ...editFormParam }
        }

        if (param.type === 'Contacts') {
            dataLoaderServices.dataLoadContactExport(ExportPayload).then((value: any) => {
                if (value) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Contracts') {
            var payload = {
                pageNumber: -1,
                pageSize: -1,
                type: param.subType
            }

            ExportPayload = { ...ExportPayload, ...payload }
            dataLoaderServices.dataLoadContractExport(ExportPayload)
        }

        if (param.type === 'Contract Links') {

            exportOption = "open"
            setExportOption(exportOption)
            //dataLoaderServices.dataLoadContractLinksExport(ExportPayload)
        }

        if (param.type === 'Upload Mechanicals') {

            var payload = {
                "type": param.subType,
                "pageNumber": -1,
                "pageSize": -1
            }

            ExportPayload = { ...ExportPayload, ...payload }

            dataLoaderServices.dataLoadMechanicalUploadExport(ExportPayload).then((value: any) => {
                if (value) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Minimum Set Uploader') {
            if (param.subType == "Tracks") {
                ExportPayload = { ...ExportPayload, ...{ exportType: "T", AssetType: "T" } }
                dataLoaderServices.assetExport(ExportPayload)
            }
            if (param.subType == "Releases") {
                ExportPayload = { ...ExportPayload, ...{ exportType: "R", AssetType: "R" } }
                dataLoaderServices.assetExport(ExportPayload)
            }
            if (param.subType == "Dealerprice") {
                dataLoaderServices.CompPricesExport(ExportPayload).then((value: any) => {
                    setviewAllListing(value); setshowViewAllResult(true);
                })
            }
            if (param.subType == "releaseTrack") {
                ExportPayload = { ...ExportPayload, ...{ ExportPayload: "T", AssetType: "T" }, ...{ exportType: "ReleaseTrackDetails" } }

                dataLoaderServices.releaseTrackExport(ExportPayload)
            }
            if (param.subType == "Songs") {
                ExportPayload = { ...ExportPayload, ...{ exportType: "S", AssetType: "S" } }
                dataLoaderServices.assetExport(ExportPayload)
            }
        }

    }

    const onPageChange = (e: any) => {
        console.log(e)
        viewAllPayload.pageNumber = e.pageNumber;
        viewAllPayload.pageSize = e.pageSize;
        ViewUploadList();
    }

    const onPageChangeSearch = (e: any) => {
        console.log(e)
        console.log(searchListingPayload)
        if (searchListingPayload.pageNumber != e.pageNumber || searchListingPayload.pageSize != e.pageSize) {
            searchListingPayload.pageNumber = e.pageNumber
            searchListingPayload.pageSize = e.pageSize
            searchForListing();
        }
    }

    const exportTemplateMapping = () => {
        console.log(param.type)
        console.log(param.subType)
        var TemTableName = '';

        if (param.subType == "Tracks" && param.type == "Minimum Set Uploader") {
            TemTableName = '[dataload].[TrackUpload]'
        }

        if (param.subType == "Releases" && param.type == "Minimum Set Uploader") {
            TemTableName = '[dataload].[ReleaseUpload]'
        }

        if (param.subType == "Dealerprice" && param.type == "Minimum Set Uploader") {
            TemTableName = '[dataload].[DealerPriceUpload]'
        }

        if (param.subType == "releaseTrack" && param.type == "Minimum Set Uploader") {
            TemTableName = '[dataload].[ReleaseTracksUpload]'
        }

        if (param.subType == "Songs" && param.type == "Minimum Set Uploader") {
            TemTableName = '[Publishing].[TempTableMinimumSetSong]'
        }

        if (param.type == "Contacts") {
            TemTableName = '[dataload].[ContactUpload]'
        }

        if (param.type == "Contracts") {
            TemTableName = '[dataload].[ContractUpload]'
        }

        if (param.type == "Contract Links") {
            TemTableName = '[dataload].[ContractLinks]'
        }

        if (param.type == "Release/Track" && param.subType == "releaseTrack") {
            TemTableName = 'MetaDataGenericV1'
        }

        if (param.type == "Release/Track" && param.subType == "Releases") {
            TemTableName = 'MetaDataGenericCompilations'
        }

        if (param.type == "Release/Track" && param.subType == "Track") {
            TemTableName = 'MetaDataGenericTracks'
        }

        if (param.type == "CUE") {
            TemTableName = '[dataload].[TempTableCUE]'
        }

        if (param.type == "Song") {
            TemTableName = '[Publishing].[TempTableSong]'
        }

        //Upload Mechanicals
        if (param.type == "Upload Mechanicals" && param.subType == "mechanicalContract") {
            TemTableName = '[dataload].[Mechanicals_Contracts]'
        }

        if (param.type == "Upload Mechanicals" && param.subType == "mechanicalTrackSplits") {
            TemTableName = '[dataload].[Mechanicals_TrackSplits]'
        }

        if (param.type == "Upload Mechanicals" && param.subType == "mechanicalLicenses") {
            TemTableName = '[dataload].[Mechanicals_All_Links]'
        }

        //Upload Mappings
        if (param.type == "Mappings" && param.subType == "mappingTerritory") {
            TemTableName = '[dataload].[Mappings_Territory]'
        }

        if (param.type == "Mappings" && param.subType == "mappingFormat") {
            TemTableName = '[dataload].[Mappings_Formats]'
        }

        if (param.type == "Mappings" && param.subType == "mappingCatalogue") {
            TemTableName = '[dataload].[Mappings_Catalogues]'
        }

        if (param.type == "Mappings" && param.subType == "mappingRaw") {
            TemTableName = '[dataload].[Mappings_Audits]'
        }

        if (param.type == "Mappings" && param.subType == "mappingAudit") {
            TemTableName = '[dataload].[Matching_Invoices]'
        }

        if (param.type == "Mappings" && param.subType == "mappingRawPub") {
            TemTableName = '[dataload].[Mappings_Audits]'
        }

        if (param.type == "Mappings" && param.subType == "mappingAuditPub") {
            TemTableName = '[dataload].[Mappings_Audits]'
        }

        if (param.type == "Mappings" && param.subType == "mappingAnalysisCode") {
            TemTableName = '[dataload].[Mappings_AnalysisCodes]'
        }

        if (param.type == "Mappings" && param.subType == "mappingClassList.excel") {
            TemTableName = '[dataload].[Mappings_ClassLists]'
        }

        if (param.type == "Mappings" && param.subType == "mappingInvoice") {
            TemTableName = '[dataload].[Matching_Invoices]'
        }

        if (param.type == "Mappings" && param.subType == "mappingSong") {
            TemTableName = '[dataload].[Mappings_Songs]'
        }

        //Data Transfer
        if (param.type == "Data Transfer") {
            TemTableName = '[dataload].[DataTransfer_Raw]'
        }

        var url = '/Api/metaData/genericV1/getAllTemplate/' + TemTableName;
        window.open(url);
    }


    const editUploader = (uploadData: any) => {
        console.log(uploadData)
        editUploaderStatus = true;
        setEditUploaderStatus(editUploaderStatus)
        editUploaderData = uploadData
        setEditUploaderData(editUploaderData)
        console.log(editUploaderStatus)
    }

    const deleteUploader = (uploadData: any) => {
        console.log(uploadData)
        deleteUploaderData = uploadData;
        setDeleteUploaderData(deleteUploaderData);
        deleteUploaderStatus = true;
        setDeleteUploaderStatus(deleteUploaderStatus);
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        if (e == 1) {
            uploadDelete();
        }
        //e==2 NO
        editUploaderStatus = false;
        setDeleteUploaderStatus(editUploaderStatus)
    }

    const uploadDelete = () => {

        console.log(param)
        console.log(deleteUploaderData)
        if (param.type == 'Contacts') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderContactDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Contracts') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloadercontractDelete(deleteUploaderData.contractUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Contract Links') {
            console.log(deleteUploaderData.contractLinkUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloadercontractLinkDelete(deleteUploaderData.contractLinkUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Release/Track' && param.subType == 'releaseTrack') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloadermetaDataGenericDelete(deleteUploaderData.metaDataGenericTempId).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Release/Track' && param.subType == 'Releases') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderMetaDataGenericCompilationsDelete(deleteUploaderData.MetaDataGenericCompilationsTempId).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Release/Track' && param.subType == 'Track') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderMetaDataGenericTrackDelete(deleteUploaderData.MetaDataGenericTracksTempId).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'CUE') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderCueDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Song') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderSongMetaDataDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Minimum Set Uploader') {

            if (param.subType == 'Track') {
                console.log(deleteUploaderData.trackUploadId)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderTrackDelete(deleteUploaderData.trackUploadId).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'Releases') {
                console.log(deleteUploaderData.releaseUploadId)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderReleaseDelete(deleteUploaderData.releaseUploadId).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'Dealerprice') {
                console.log(deleteUploaderData.dealerPriceUploadID)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderDealerPriceDelete(deleteUploaderData.dealerPriceUploadID).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'releaseTrack') {
                console.log(deleteUploaderData.releaseTracksUploadId)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderReleaseTrackDelete(deleteUploaderData.releaseTracksUploadId).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'Songs') {
                console.log(deleteUploaderData.tempTableMinimumSetSongID)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderSongDelete(deleteUploaderData.tempTableMinimumSetSongID).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }
        }
    }

    const apiRespondMgt = (respond: any, respondFor: any) => {

        if (respond && respondFor == "Delete") {
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " Successful", "Success");
            ViewUploadList();
            uploadDataCounting();
        }

        if (!respond && respondFor == "Delete") {
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " fail", "fail");
            ViewUploadList();
            uploadDataCounting();
        }

        if (respond && respondFor == "Table Clear") {
            uploadDataCounting();
            uploadDataCounting();
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " Successful", "Success");
        }

        if (!respond && respondFor == "Table Clear") {
            uploadDataCounting();
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " fail", "fail");
        }
    }

    const onChangeEditLoad = (e: any) => {
        editUploaderStatus = false;
        setEditUploaderStatus(editUploaderStatus)
        ViewUploadList();
        uploadDataCounting();
    }

    return (
        <>

            {showShearchField && <div className="box mtl">

                <div className="box-header well">
                    <h2 className="ws-6">Search</h2>

                    <div className="ws-6">
                        <button className="icon-btn info pull-right m2" onClick={() => setcollapsedSearch(!collapsedSearch)}>
                            <i className={collapsedSearch ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                        </button>
                    </div>

                </div>

                {collapsedSearch && <>
                    <div className="box-content">


                        <div className="row-fluid ws-12">
                            {dataLoaderServices.dataLoaderSearch?.map((valueMapping: any) => {
                                {
                                    if (valueMapping.fieldFor === param.type && !valueMapping.for) {
                                        return (
                                            valueMapping.field_display?.map((fieldName: any, index: any) => {
                                                return (
                                                    <div className={valueMapping.className}>
                                                        <div className="form-format">
                                                            <label className="control-label">{fieldName}</label>
                                                            <div className="label-entries ws-10">
                                                                <input id={valueMapping.field_code[index]} name={valueMapping.field_code[index]} type="text" placeholder={fieldName}
                                                                    value={editFormParam && editFormParam[valueMapping.field_code[index]] ? editFormParam[valueMapping.field_code[index]] : ""}
                                                                    onChange={(e) => sliderUpdateEditFormParam(valueMapping.field_code[index], editFormParam, "text", e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        )
                                    }

                                    if (valueMapping.fieldFor === param.type && valueMapping.for && valueMapping.for === param.subType) {
                                        return (
                                            valueMapping.field_display?.map((fieldName: any, index: any) => {
                                                return (
                                                    <div className={valueMapping.className}>
                                                        <div className="form-format">
                                                            <label className="control-label">{fieldName}</label>
                                                            <div className="label-entries ws-10">
                                                                <input id={valueMapping.field_code[index]} name={valueMapping.field_code[index]} type="text" placeholder={fieldName}
                                                                    value={editFormParam && editFormParam[valueMapping.field_code[index]] ? editFormParam[valueMapping.field_code[index]] : ""}
                                                                    onChange={(e) => sliderUpdateEditFormParam(valueMapping.field_code[index], editFormParam, "text", e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        )
                                    }
                                }
                            })}

                            {(() => {

                                if (param.type === "Contract Links") {
                                    return (
                                        <div className="span2-4 m0 prl pl pull-left mtl">
                                            Unlinked Only
                                            <label className="switch mr">
                                                <input type="checkbox" onChange={() => seteditFormParam({ ...editFormParam, unlinked: editFormParam?.unlinked ? 0 : 1 })} />
                                                {editFormParam?.unlinked == 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                                {editFormParam?.unlinked != 1 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                            </label>

                                        </div>
                                    )
                                }

                            })()}
                        </div>

                    </div>

                    <div className="pm pull-right">
                        <button className="icon-btn edit" onClick={searchForListing}> <i className="icon-search"></i> </button>
                        <button className="icon-btn delete" onClick={() => seteditFormParam([])}> <i className="icon-refresh"></i>   </button>
                        <button className="icon-btn primary" onClick={exportListing}> <i className="icon-download1"></i> </button>
                    </div>
                </>}

                {showSearchResult && <div className="box">
                    <div className="row-fluid">
                        <div className="ws-12">
                            <div className="box-header well">  <h2 ><i className="icon-info"></i> {searchtotalRows} record(s) found</h2> </div>

                            <div className="box-content">
                                {(searchtotalRows === 0) && <div className="alert alert-info">No data to display for this search </div>}

                                {(searchtotalRows > 0) && <div className="table-responsive allowHscroll">
                                    <table className="newTable">
                                        <thead>
                                            <tr>
                                                {dataLoaderServices.SearchfieldName.map((value: any, index: any) => {

                                                    if (value.fieldFor === param.type && !value.for) {
                                                        return (
                                                            dataLoaderServices.SearchfieldName[index].fieldName?.map((valueMap) => {
                                                                return (<> <th className='forceSingleLine'>{valueMap}</th>  </>)
                                                            })
                                                        )
                                                    }

                                                    if (value.fieldFor === param.type && value.for && value.for == param.subType) {
                                                        return (
                                                            dataLoaderServices.SearchfieldName[index].fieldName?.map((valueMap) => {
                                                                return (<> <th className='forceSingleLine'>{valueMap}</th>  </>)
                                                            })
                                                        )
                                                    }
                                                })}
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {searchListing?.map((searchValue: any) => {
                                                return (
                                                    <tr>
                                                        {dataLoaderServices.SearchfieldName.map((value: any, index: any) => {

                                                            if (value.fieldFor === param.type && !value.for) {
                                                                return (
                                                                    dataLoaderServices.SearchfieldName[index].fieldCode?.map((valueMap) => {
                                                                        return (<> <td className='forceSingleLine'>{searchValue[valueMap]}</td>  </>)
                                                                    })
                                                                )

                                                            }

                                                            if (value.fieldFor === param.type && value.for && value.for == param.subType) {
                                                                return (
                                                                    dataLoaderServices.SearchfieldName[index].fieldCode?.map((valueMap) => {
                                                                        return (<> <td className='forceSingleLine'>{searchValue[valueMap]}</td>  </>)
                                                                    })
                                                                )

                                                            }

                                                        })}
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}

                                {searchtotalRows > 10 && <div className="clearfix">
                                    <Pagination totalRow={searchtotalRows} onPageChange={onPageChangeSearch} />
                                </div>}

                            </div>
                        </div>
                    </div>
                </div>}
            </div>}

            <div className="box mtl">

                {(param.subType !== "Distributor") && <div className='ws-12'>
                    <div className="box-header well">
                        <h2 className="ws-6 ">File Details</h2>
                        <div className="ws-6">
                            {(param.type != "CWR") && <button title="Download Templates" className="icon-btn edit pull-right btn-m" onClick={exportTemplateMapping}>  <i className="icon-download"></i> </button>}
                            {(param.type != "CWR") && <button title="Log History" className="icon-btn primary pull-right btn-m" onClick={() => { setLoadFileStatus(true); setopenLoadFile(4) }}><i className="icon-history"></i> </button>}
                            {(param.type != "CWR") && <button title="Refresh" className="icon-btn delete pull-right btn-m" onClick={() => { uploadDataCounting() }}><i className="icon-refresh2"></i></button>}
                        </div>
                    </div>

                    <div className="box-content">
                        <div className="ws-12">
                            <div >
                                <div className="label-entries">
                                    <label className="icon-btn labelInfo width120 height35 mt mrl" >
                                        Upload File
                                        <input type="file" accept='pdf/*' key="file" onChange={(e) => fileupload(e)} className="hide" />
                                    </label>
                                    {(fileuploadStatus) && <button className="icon-btn edit width100 height35 mt mrl" onClick={() => { setLoadFileStatus(true); setopenLoadFile(1) }}>  Load  </button>}

                                </div>
                            </div>

                            <div className="ws-6 mt height35">
                                <div className="progress m1">
                                    <div className="progress-fill" style={{ width: `${progress}%` }}>  {progress} % </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {(viewAlltotalRows > 0) && <div className="pm pull-right">
                        {(param.type !== "CWR") && <button className="icon-btn delete pull-left height35 btn-m" onClick={() => { setLoadFileStatus(true); setopenLoadFile(2) }}><i className="icon-trashcan"></i></button>}
                        {(param.type !== "CWR") && <button className="icon-btn edit width100 height35" onClick={ViewUploadList}>View All</button>}
                        {(param.type !== "") && <button className="icon-btn delete width100 height35" onClick={() => { setLoadFileStatus(true); setopenLoadFile(3) }}> Validate  </button>}
                    </div>}

                </div>}

                {(param.subType === "Distributor") && <div className='ws-12'>
                    <div className="box-header well">
                        <h2 className="ws-6 ">Distributor Details</h2>
                        <div className="ws-6">
                            {((param.type != "CWR")) && <button title="Download Templates" className="icon-btn edit pull-right" onClick={exportTemplateMapping}>  <i className="icon-download"></i> </button>}
                            {((param.type != "CWR")) && <button title="Log History" className="icon-btn primary pull-right" onClick={() => { setLoadFileStatus(true); setopenLoadFile(4) }}><i className="icon-history"></i> </button>}
                        </div>
                    </div>

                    <div className="box-content">

                        <div className="ws-12">
                            <label className="control-label w-6 mt" >  XML file(s)</label>
                            <div className="label-entries ws-9">
                                <button className="icon-btn info" data-ng-click="uploadXML()" title="Download">
                                    <i className="icon-download1"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    {(viewAlltotalRows > 0) && <div className="pm pull-right">
                        <button className="icon-btn delete pull-left height35" onClick={() => { setLoadFileStatus(true); setopenLoadFile(2) }}><i className="icon-trashcan"></i></button>
                        <button className="icon-btn edit width100 height35" onClick={ViewUploadList}>View All</button>
                        <button className="icon-btn delete width100 height35 " onClick={() => { setLoadFileStatus(true); setopenLoadFile(3) }}> Validate  </button>
                    </div>}

                </div>}
            </div>

            {(showViewAllResult) && <div className="box" >
                <div className="box-header well"> <h2>{viewAlltotalRows} record(s) found</h2> </div>

                <div className="box-content">

                    {(viewAlltotalRows > 0) && <div className="table-responsive allowVscroll allowHscroll">
                        <table className="newTable">
                            <thead>
                                <tr>
                                    {dataLoaderServices.viewAllfieldName?.map((viewMap: any) => {
                                        if (viewMap.fieldFor === param.type && !viewMap.for) {
                                            return (
                                                viewMap.fieldName?.map((naming: any) => {
                                                    return (
                                                        <th className='forceSingleLine'>{naming}</th>
                                                    )
                                                })
                                            )
                                        }

                                        if (viewMap.fieldFor === param.type && viewMap.for && viewMap.for === param.subType) {
                                            return (
                                                viewMap.fieldName?.map((naming: any) => {
                                                    return (
                                                        <th className='forceSingleLine'>{naming}</th>
                                                    )
                                                })
                                            )
                                        }

                                    })}

                                    {(param.type != 'Data Transfer' && param.type != 'Mappings' && param.type != 'Upload Mechanicals') && <th style={{ width: "14%" }}>Operation</th>}
                                </tr>
                            </thead>
                            <tbody>

                                {viewAllListing?.map((searchValue: any) => {
                                    return (
                                        <tr>
                                            {dataLoaderServices?.viewAllfieldName.map((value: any, index: any) => {

                                                if (value.fieldFor === param.type && !value.for) {
                                                    return (

                                                        value.fieldCode?.map((valueMap: any) => {
                                                            return (<> <td className='forceSingleLine'>{searchValue[valueMap]}</td>  </>)
                                                        })
                                                    )
                                                }

                                                if (value.fieldFor === param.type && value.for && value.for === param.subType) {
                                                    return (

                                                        value.fieldCode?.map((valueMap: any) => {
                                                            return (<> <td className='forceSingleLine'>{searchValue[valueMap]}</td>  </>)
                                                        })
                                                    )
                                                }

                                            })}
                                            {(param?.type != 'Data Transfer' && param?.type != 'Mappings' && param?.type != 'Upload Mechanicals')
                                                && <td className='forceSingleLine ws-12'>

                                                    <div style={{ width: "95px" }}>
                                                        <button title="Edit" onClick={() => editUploader(searchValue)} className="icon-btn edit btn-m"><i className="icon-pencil"></i></button>
                                                        <button title="Delete" onClick={() => deleteUploader(searchValue)} className="icon-btn delete btn-m"><i className="icon-trash"></i></button>

                                                    </div>
                                                </td>}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                    </div>}

                    {viewAlltotalRows > 10 && <div className="clearfix">
                        <Pagination totalRow={viewAlltotalRows} onPageChange={onPageChange} />
                    </div>}

                </div>
            </div>}

            {(() => {

                if (openLoadFile === 1) {
                    return (<DataLoaderLoadFile onChangeLoadFile={onChangeLoadFile} open={LoadFileStatus} type={param.type} subType={param.subType} />)
                }

                if (openLoadFile === 2) {
                    return (<DataLoaderTableConfirmation onClearConfirmation={onClearConfirmation} open={LoadFileStatus} />)
                }

                if (openLoadFile === 3) {
                    return (<DataLoaderFileValidation onFileValidation={onFileValidation} open={LoadFileStatus} type={param.type} subType={param.subType} uploadCount={viewAlltotalRows} />)
                }

                if (openLoadFile === 4) {
                    return (<DataLoaderFileLog onChangeLogFile={onChangeLogFile} open={LoadFileStatus} type={LogName} />)
                }

                if (editUploaderStatus && editUploaderData) {
                    return (<DataLoaderEditLoad onChangeEditLoad={onChangeEditLoad} open={editUploaderStatus} type={param.type} subType={param.subType} data={editUploaderData} />)
                }

                if (deleteUploaderStatus) {
                    return <DeleteDialogueBox param={deleteUploaderStatus} message={"delete the record"} onChange={deleteConfirmation} />
                }


                if (exportOption && exportOption.length > 0) {
                    return <ExportOption exportOption={exportOption} onChange={onChange} fileName={(param?.type + '_' + param?.subType).replace(/ /g, "")} />
                }
            })()}
        </>
    )
}